module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/issues/internal/internal-grid/internal-grid.component.css
// module id = ./src/app/issues/internal/internal-grid/internal-grid.component.css
// module chunks = main